@switch (tag()) {
  @case ("h1") {
    <h1
      [class]="gradient() || ''"
      [style.color]="gradient() ? undefined : color()"
      [style.font-size]="size().fontSize"
      [style.font-weight]="fontWeight()"
      [style.line-height]="size().lineHeight"
      [style.letter-spacing]="size().letterSpacing"
      [style.font-family]="fontFamily()"
      [style.text-align]="alignment()"
      [style.white-space]="whiteSpace()"
    >
      {{ text() }}
    </h1>
  }
  @case ("h2") {
    <h2
      [class]="gradient() || ''"
      [style.color]="gradient() ? undefined : color()"
      [style.font-size]="size().fontSize"
      [style.font-weight]="fontWeight()"
      [style.line-height]="size().lineHeight"
      [style.letter-spacing]="size().letterSpacing"
      [style.font-family]="fontFamily()"
      [style.text-align]="alignment()"
      [style.white-space]="whiteSpace()"
    >
      {{ text() }}
    </h2>
  }
  @case ("h3") {
    <h3
      [class]="gradient() || ''"
      [style.color]="gradient() ? undefined : color()"
      [style.font-size]="size().fontSize"
      [style.font-weight]="fontWeight()"
      [style.line-height]="size().lineHeight"
      [style.letter-spacing]="size().letterSpacing"
      [style.font-family]="fontFamily()"
      [style.text-align]="alignment()"
      [style.white-space]="whiteSpace()"
    >
      {{ text() }}
    </h3>
  }
  @case ("h4") {
    <h4
      [class]="gradient() || ''"
      [style.color]="gradient() ? undefined : color()"
      [style.font-size]="size().fontSize"
      [style.font-weight]="fontWeight()"
      [style.line-height]="size().lineHeight"
      [style.letter-spacing]="size().letterSpacing"
      [style.font-family]="fontFamily()"
      [style.text-align]="alignment()"
      [style.white-space]="whiteSpace()"
    >
      {{ text() }}
    </h4>
  }
  @case ("h5") {
    <h5
      [class]="gradient() || ''"
      [style.color]="gradient() ? undefined : color()"
      [style.font-size]="size().fontSize"
      [style.font-weight]="fontWeight()"
      [style.line-height]="size().lineHeight"
      [style.letter-spacing]="size().letterSpacing"
      [style.font-family]="fontFamily()"
      [style.text-align]="alignment()"
      [style.white-space]="whiteSpace()"
    >
      {{ text() }}
    </h5>
  }
  @default {
    <p
      [class]="gradient() || ''"
      [style.color]="gradient() ? undefined : color()"
      [style.font-size]="size().fontSize"
      [style.font-weight]="fontWeight()"
      [style.line-height]="size().lineHeight"
      [style.letter-spacing]="size().letterSpacing"
      [style.font-family]="fontFamily()"
      [style.text-align]="alignment()"
      [style.white-space]="whiteSpace()"
    >
      {{ text() }}
    </p>
  }
}
